const isObject = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

export const arrayOrEmpty = (value) => (Array.isArray(value) ? value : []);

const objectOrEmpty = (value) => (isObject(value) ? value : {});

// Keep the result UI resilient to nil Go slices and partially populated lender
// results. A nil slice is encoded as JSON null, while the UI consumes arrays.
export function normalizePpeEngineResponse(payload) {
  const response = objectOrEmpty(payload);

  return {
    ...response,
    connected_lender_map: objectOrEmpty(response.connected_lender_map),
    result: arrayOrEmpty(response.result)
      .filter(isObject)
      .map((lenderResult) => ({
        ...lenderResult,
        ProductRatesCosts: arrayOrEmpty(lenderResult.ProductRatesCosts)
          .filter(isObject)
          .map((productRateCost) => {
            const product = objectOrEmpty(productRateCost.product);

            return {
              ...productRateCost,
              product: {
                ...product,
                Name: typeof product.Name === "string" ? product.Name : "",
                Mtype: typeof product.Mtype === "string" ? product.Mtype : "",
                IncomeDocTypes: arrayOrEmpty(product.IncomeDocTypes),
              },
              AUSEngine: arrayOrEmpty(productRateCost.AUSEngine),
              rateCosts: arrayOrEmpty(productRateCost.rateCosts)
                .filter(isObject)
                .map((rateCost) => ({ ...rateCost })),
            };
          }),
      })),
  };
}

// An empty product AUS list means the lender does not restrict underwriting
// engines. Otherwise, at least one selected engine must be supported.
export function supportsSelectedAus(productAus, selectedAus) {
  const supported = arrayOrEmpty(productAus);
  if (supported.length === 0) return true;

  return arrayOrEmpty(selectedAus).some((option) =>
    supported.includes(option?.label ?? option)
  );
}
